import { ImpactedDelivery } from "./ImpactedDelivery";

export interface ActiveEvent {
    eventId: number;
    eventDisplayName: string;
    type: EventType;
    createdAt: Date;
    isClosed: boolean;
    priority: string;
    eventStatusId: number;
    impactedDeliveries: ImpactedDelivery[];
    reviewerUserId: string;
    qaUserId: string;
}

export enum EventType {
    transportation = "Transportation",
    site = "Site",
}
